import React, { Component, Fragment } from 'react';

class PreviewLayerFooter extends Component {
  render () {
    const { onClose } = this.props;
    return (
      <div className="layer_foot">
        <button className="btn_close" onClick={onClose}>
          <span className="inner_btn">
            <span className="mce-ico ico_close">닫기</span>
          </span>
        </button>
      </div>
    );
  }
}

export default PreviewLayerFooter;
